"use client";

import type { ReactNode } from "react";
import { PostHogProvider as PHProvider } from "@posthog/react";
import posthog from "posthog-js";

import { isPostHogEnabled } from "../env";

/**
 * PostHogProvider component for Next.js App Router.
 * This provider wraps your app and makes PostHog available via React hooks
 * like usePostHog, useFeatureFlagEnabled, etc.
 * PostHog is initialized in instrumentation-client.ts, so this provider
 * just passes the already-initialized client to the React context.
 */
export function PostHogProvider({ children }: { children: ReactNode }) {
  // Only provide PostHog context if it's enabled and we're on the client
  // PostHog is initialized in instrumentation-client.ts before the app renders,
  // so we don't need to check if it's initialized here
  if (!isPostHogEnabled()) {
    return <>{children}</>;
  }

  return <PHProvider client={posthog}>{children}</PHProvider>;
}
